<template>
	<dvi class="user-machine-alarm">
		<search-user-machine-alarm
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:alarmTypeList="alarmTypeList"
			:search="search"
			:dateTime="dateTime"
		>
		</search-user-machine-alarm>
		<div class="table vue-padding">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="userMachineAlarmList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="userName"
					:label="$t('userMachineAlarm.userName')"
					width="250"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="equipmentNo"
					:label="$t('userMachineAlarm.equipmentNo')"
					width="150"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="type"
					:label="$t('userMachineAlarm.alarmType')"
					width="150"
					:align="'center'"
					:formatter="alarmType"
				></el-table-column>
				<el-table-column
					prop="aisleNo"
					:label="$t('userMachineAlarm.hdNo')"
					width="120"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="orderNumber"
					:label="$t('userMachineAlarm.orderNum')"
					width="170"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="code"
					:label="$t('userMachineAlarm.alarmCode')"
					width="150"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="info"
					:label="$t('userMachineAlarm.alarmInfo')"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('userMachineAlarm.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
			</el-table>
			<el-pagination
				v-if="userMachineAlarmList.length > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</dvi>
</template>

<script>
import searchUserMachineAlarm from "_c/machine/user/SearchUserMachineAlarm";
export default {
	name: "UserMachineAlarm",
	components: {
		searchUserMachineAlarm,
	},
	data() {
		return {
			search: {
				startTime: "",
				endTime: "",
				userName: "",
				equipmentNo: "",
				type: "",
			},
			dateTime: [],
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			loading: false,
			userMachineAlarmList: [],
			alarmTypeList: [],
		};
	},
	mounted() {
		let _self = this;
		if (_self.dateTime.length < 1) {
			_self.getDefault();
		}
		_self.currentChange();
		_self.listAlarmTypeList();
	},
	methods: {
		getDefault() {
			let _self = this;
			//  var today = _self.getTime(new Date(new Date().toLocaleDateString()));
			var startday = "";
			var endday = "";
			for (var j = 0; j <= 30; j++) {
				let thirtyDays =
					new Date(new Date().toLocaleDateString()).getTime() -
					j * 3600 * 24 * 1000;
				thirtyDays = _self.getTime(thirtyDays);
				if (j == 0) {
					endday = thirtyDays;
				} else if (j == 6) {
					startday = thirtyDays;
				}
			}
			_self.search.startTime = startday + " 00:00:00";
			_self.search.endTime = endday + " 23:59:59";
			_self.dateTime = [
				new Date(_self.search.startTime),
				new Date(_self.search.endTime),
			];
		},
		getTime(nS) {
			//  获取一个时间对象
			var date = new Date(nS);
			//  获取完整的年份(4位,1970)
			let y = date.getFullYear();
			//  获取月份(0-11,0代表1月,用的时候记得加上1)
			let m =
				date.getMonth() + 1 < 10
					? "0" + (date.getMonth() + 1)
					: date.getMonth() + 1;
			//  获取日(1-31)
			let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
			return y + "-" + m + "-" + d;
		},
		listAlarmTypeList() {
			this.$api.dict("gp_alarm_type").then(res => {
				if (res.code === 0) {
					this.alarmTypeList = res.data;
				}
			});
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.AlarmRecord.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.userMachineAlarmList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		alarmType(row) {
			return this.$cloud.getDictLabel(this.alarmTypeList, row.type);
		},
		onSubmit(data) {
			this.search = data;
			this.dateTime = [new Date(data.startTime), new Date(data.endTime)];
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			this.getDefault();
			this.currentChange();
		},
	},
};
</script>

<style lang="scss"></style>
